// extracted by mini-css-extract-plugin
module.exports = {"customMenu":"Menu_customMenu__1kf1N","navbarHidden":"Menu_navbarHidden__1f5wy"};